import { PageRequest } from '@/core/request/PageRequest';
import { Moment } from 'moment';

export type ModalType = 'part' | 'consumable';

export enum ItemDeliveryDetailTypeEnum {
  undefined = 'domain.enums.item_type.undefined',
  part = 'domain.enums.item_type.part',
  consumable = 'domain.enums.item_type.consumable',
}

export const ItemDeliveryDetailType = {
  [ItemDeliveryDetailTypeEnum.undefined]: '-',
  [ItemDeliveryDetailTypeEnum.part]: 'Peça',
  [ItemDeliveryDetailTypeEnum.consumable]: 'Insumo',
};

export interface ListStockPartsDeliveryDataSupport {
  isConsumableNoLink?: boolean;
  availableQuantity: number;
  requestedQuantity: number;
  workOrderItemId: number;
  workOrderId?: number;
  manufacturingCode: string;
  description: string;
  licensePlate?: string;
  provided?: string;
  deliveredQuantity: number;
  complementId?: number;
  consumableId?: number;
  costPrice?: number;
  subArea?: {
    id: number;
    name: string;
    nickName?: string;
  };
  subareaId?: number;
  complementItemId?: number;
  workOrderComplementId?: number;
  workOrderNumber?: string;
  sku?: string;
  barcode?: string;
  companyCode?: string;
  prices: number;
  includeOutOfStock?: boolean;
  partId?: number;
}

export interface ListStockPartsDeliveryData {
  deliveredQuantity?: number;
  complementId?: number;
  complementItemId?: number;
  consumableId?: number;
  costPrice?: number;
  subareaId?: number;
  deliveredItemId?: string;
}

export interface listStockPartsDeliveryRequest extends PageRequest {
  availableQuantity?: number;
  requestedQuantity?: number;
  complementId?: number;
  workOrderId?: number;
  manufacturingCode?: string;
  description?: string;
  licensePlate?: string;
}

export interface listStockPartsDeliveryResponse {
  nextToken: number;
  data: ListStockPartsDeliveryData[];
}

export interface deliveryMaterialDTO {
  id: number;
  companyId: number;
  deliveryDate: string;
  deliveryDateMoment?: Moment;
  deliverymanId: number;
  receiverId: number;
  observations: string;
  deliveredItemsSupport: ListStockPartsDeliveryDataSupport[];
  deliveredItems: ListStockPartsDeliveryData[];
  prices: number;
}

export interface DeliveryMaterialCreateResponse {
  result: {
    id: number;
    companyId: number;
    deliveryDate: string;
    deliveryDateMoment?: Moment;
    deliverymanId: number;
    receiverId: number;
    observations: string;
    deliveredItemsSupport: ListStockPartsDeliveryDataSupport[];
    deliveredItems: ListStockPartsDeliveryData[];
    prices: number;
  };
}

export interface deliveryMaterialRequest extends PageRequest {
  companyId?: number;
  filter?: string;
}

export enum DeliveryDetailType {
  undefined = 0,
  part = 1,
  consumable = 2,
}

export const DeliveryDetailLabels = {
  [DeliveryDetailType.undefined]: '-',
  [DeliveryDetailType.part]: 'Peça',
  [DeliveryDetailType.consumable]: 'Insumo',
};

export interface DeliveryReturnItem {
  workOrderId: number;
  workOrderComplementId: number;
  internalCode: string;
  description: string;
  type: DeliveryDetailType;
  requestQuantity: number;
  deliveredQuantity: number;
  WorkOrderNumber: string;
  costPrice: number;
  manufacturingCode: string | null;
  workOrderNumber: string;
}

export interface DeliveryDetailsIdResult {
  companyId: number;
  deliveredDate: string;
  deliveryMan: number;
  deliveryManName: string;
  receivedMan: number;
  receivedManName: string;
  itemReturnDetail: DeliveryReturnItem[];
  itemDeliveryDetail: DeliveryReturnItem[];
}

export interface DeliveryDetailsIdResponse {
  result: DeliveryDetailsIdResult;
}
